import { useCallback } from 'react';
import { listarColetas } from '../api/coletas.js';
import { seInformado } from '../api/recorte.js';
import { useConsulta } from '../api/useConsulta.js';
import { inicioDoPeriodo, PERIODO_PADRAO } from '../pages/movimentacoes/formato.js';

/**
 * Quantas coletas existem no período que a tela abre — o contador da barra
 * lateral.
 *
 * Vinha de `dados-exemplo/navegacao.ts` com o valor fixo `1.284`, e isso passou
 * a ser mentira no dia em que a tela de Coletas começou a consumir a API: o
 * contador dizia mil e duzentas e a tabela ao lado mostrava uma. Mesmo desenho
 * do selo de Dispositivos, e pelo mesmo motivo — número que não corresponde a
 * nada ensina o supervisor a ignorar todos os outros.
 *
 * **O período é o mesmo que a listagem usa por padrão**, e essa costura é
 * deliberada: um contador "geral" ao lado de uma tela recortada em 7 dias
 * mostraria 12 no menu e 3 na tabela, e quem visse a diferença não teria como
 * saber qual dos dois está certo.
 *
 * Pede `tamanho: 1` porque só o `total` interessa — a contagem é do servidor,
 * com o mesmo filtro, e não uma soma feita aqui.
 *
 * `null` enquanto não se sabe (ou se a consulta falhou): o contador não aparece,
 * em vez de aparecer zerado — "nenhuma coleta" é uma afirmação sobre o armazém,
 * e ela não foi verificada.
 */
export function useResumoDeColetas(): number | null {
  const contar = useCallback(
    () =>
      listarColetas({
        pagina: 1,
        tamanho: 1,
        ...seInformado('de', inicioDoPeriodo(PERIODO_PADRAO)),
      }),
    [],
  );

  return useConsulta(contar).dados?.total ?? null;
}
